module.exports = __webpack_public_path__ + "img/astral_22.3960ad24.svg";